import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { IVideo } from '../models/models'

export class GetVideosByCategoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'Video/getByCategory',
      requesterInfo,
    })
  }

  public async getVideosByCategory(categoryId: number): Promise<IVideo[]> {
    return await this.getAsync<IVideo[]>(categoryId.toString())
  }
}
